// GENERATED by scripts/icons/sync.mjs from packages/ui/icons/catalog.json.
// system glyphs; edit the catalog, never this file.

import type { IconSvgElement } from '@hugeicons/react';
import {
  AddMoneyCircleIcon as AddMoneyCircleIconSolid,
  AffiliateIcon as AffiliateIconSolid,
  Agreement01Icon as Agreement01IconSolid,
  AiFileIcon as AiFileIconSolid,
  Alert01Icon as Alert01IconSolid,
  ArrowDataTransferHorizontalIcon as ArrowDataTransferHorizontalIconSolid,
  ArrowDown01Icon as ArrowDown01IconSolid,
  ArrowUp01Icon as ArrowUp01IconSolid,
  Award01Icon as Award01IconSolid,
  BadgeInfoIcon as BadgeInfoIconSolid,
  Bookmark02Icon as Bookmark02IconSolid,
  BrowserIcon as BrowserIconSolid,
  Calendar03Icon as Calendar03IconSolid,
  CancelCircleIcon as CancelCircleIconSolid,
  Cash01Icon as Cash01IconSolid,
  ChampionIcon as ChampionIconSolid,
  ChartCandleIcon as ChartCandleIconSolid,
  ChartRoseIcon as ChartRoseIconSolid,
  CheckmarkCircle02Icon as CheckmarkCircle02IconSolid,
  CircleArrowDown02Icon as CircleArrowDown02IconSolid,
  CircleIcon as CircleIconSolid,
  Clock01Icon as Clock01IconSolid,
  Clock04Icon as Clock04IconSolid,
  Coins01Icon as Coins01IconSolid,
  Comment03Icon as Comment03IconSolid,
  ConfusedIcon as ConfusedIconSolid,
  ConstructionIcon as ConstructionIconSolid,
  Copy01Icon as Copy01IconSolid,
  DashboardSquare01Icon as DashboardSquare01IconSolid,
  Edit03Icon as Edit03IconSolid,
  FilterVerticalIcon as FilterVerticalIconSolid,
  FireIcon as FireIconSolid,
  FlashIcon as FlashIconSolid,
  GiftIcon as GiftIconSolid,
  Grid02Icon as Grid02IconSolid,
  GridViewIcon as GridViewIconSolid,
  HelpCircleIcon as HelpCircleIconSolid,
  Image02Icon as Image02IconSolid,
  InformationCircleIcon as InformationCircleIconSolid,
  Layers01Icon as Layers01IconSolid,
  LimitationIcon as LimitationIconSolid,
  Link01Icon as Link01IconSolid,
  LinkForwardIcon as LinkForwardIconSolid,
  LiveStreaming02Icon as LiveStreaming02IconSolid,
  MinusSignCircleIcon as MinusSignCircleIconSolid,
  MoneyBag01Icon as MoneyBag01IconSolid,
  MoneyExchange01Icon as MoneyExchange01IconSolid,
  Moon02Icon as Moon02IconSolid,
  More01Icon as More01IconSolid,
  PaintBoardIcon as PaintBoardIconSolid,
  Plant04Icon as Plant04IconSolid,
  PlusSignCircleIcon as PlusSignCircleIconSolid,
  RainbowIcon as RainbowIconSolid,
  Rocket01Icon as Rocket01IconSolid,
  SecurityIcon as SecurityIconSolid,
  Settings02Icon as Settings02IconSolid,
  Shapes01Icon as Shapes01IconSolid,
  SparklesIcon as SparklesIconSolid,
  Square01Icon as Square01IconSolid,
  SquareLock02Icon as SquareLock02IconSolid,
  StarAward01Icon as StarAward01IconSolid,
  Target02Icon as Target02IconSolid,
  TaskEdit01Icon as TaskEdit01IconSolid,
  TextFontIcon as TextFontIconSolid,
  Tick01Icon as Tick01IconSolid,
  ToggleOnIcon as ToggleOnIconSolid,
  Touch01Icon as Touch01IconSolid,
  TradeUpIcon as TradeUpIconSolid,
  User03Icon as User03IconSolid,
  UserCircleIcon as UserCircleIconSolid,
  UserGroup02Icon as UserGroup02IconSolid,
  UserGroup03Icon as UserGroup03IconSolid,
  UserLove01Icon as UserLove01IconSolid,
  UserMultiple02Icon as UserMultiple02IconSolid,
  WalletCardsIcon as WalletCardsIconSolid,
  Wrench01Icon as Wrench01IconSolid,
} from '@hugeicons-pro/core-solid-standard';
import {
  Alert01Icon,
  Alert02Icon,
  AngryIcon,
  Archive02Icon,
  ArrowDataTransferHorizontalIcon,
  ArrowDataTransferVerticalIcon,
  ArrowDown01Icon,
  ArrowDown03Icon,
  ArrowDownLeft01Icon,
  ArrowDownOneZeroIcon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  ArrowUpOneZeroIcon,
  ArrowUpRight01Icon,
  Award01Icon,
  Bookmark02Icon,
  BookOpen02Icon,
  BubbleChatQuestionIcon,
  Bug01Icon,
  CalculatorIcon,
  Calendar03Icon,
  Camera01Icon,
  Cancel01Icon,
  CancelCircleIcon,
  Chart01Icon,
  ChartBarLineIcon,
  ChartUpIcon,
  CheckmarkBadge01Icon,
  CheckmarkCircle02Icon,
  CheckUnread01Icon,
  CircleIcon,
  Clock01Icon,
  Coins01Icon,
  CommandIcon,
  ComputerIcon,
  ConstructionIcon,
  Copy01Icon,
  DashboardSquare01Icon,
  Delete02Icon,
  DocumentValidationIcon,
  DollarCircleIcon,
  Download01Icon,
  DropletIcon,
  Edit02Icon,
  ExpandIcon,
  FavouriteIcon,
  FilterVerticalIcon,
  FireIcon,
  FlashIcon,
  GalleryHorizontalEndIcon,
  GiftIcon,
  GitBranchIcon,
  Globe02Icon,
  HexagonIcon,
  Home01Icon,
  HourglassIcon,
  IdeaIcon,
  JusticeScale01Icon,
  Layers01Icon,
  Link01Icon,
  Link02Icon,
  Loading03Icon,
  Location01Icon,
  Login01Icon,
  Logout01Icon,
  Mail02Icon,
  MarketAnalysisIcon,
  Menu01Icon,
  Message01Icon,
  Moon02Icon,
  MoreHorizontalIcon,
  NeutralIcon,
  Notification02Icon,
  PaintBoardIcon,
  Plant01Icon,
  PlugSocketIcon,
  PlusSignIcon,
  Pulse02Icon,
  RadioButtonIcon,
  Relieved01Icon,
  RepeatIcon,
  Rocket01Icon,
  RotateClockwiseIcon,
  Search01Icon,
  Search02Icon,
  SearchRemoveIcon,
  SentIcon,
  Settings01Icon,
  Settings02Icon,
  Shield01Icon,
  ShieldUserIcon,
  ShoppingCart01Icon,
  SidebarLeftIcon,
  SlidersVerticalIcon,
  SmartPhone01Icon,
  SparklesIcon,
  SquareLock02Icon,
  StarIcon,
  Sun03Icon,
  Tick02Icon,
  Timer01Icon,
  TradeUpIcon,
  Upload01Icon,
  User03Icon,
  UserIcon,
  UserMultiple02Icon,
  UserMultipleIcon,
  ViewOffIcon,
  VolumeHighIcon,
  VolumeOffIcon,
  Wallet01Icon,
} from '@hugeicons-pro/core-stroke-standard';

export {
  AddMoneyCircleIconSolid,
  AffiliateIconSolid,
  Agreement01IconSolid,
  AiFileIconSolid,
  Alert01Icon,
  Alert01IconSolid,
  Alert02Icon,
  AngryIcon,
  Archive02Icon,
  ArrowDataTransferHorizontalIcon,
  ArrowDataTransferHorizontalIconSolid,
  ArrowDataTransferVerticalIcon,
  ArrowDown01Icon,
  ArrowDown01IconSolid,
  ArrowDown03Icon,
  ArrowDownLeft01Icon,
  ArrowDownOneZeroIcon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  ArrowUp01IconSolid,
  ArrowUpOneZeroIcon,
  ArrowUpRight01Icon,
  Award01Icon,
  Award01IconSolid,
  BadgeInfoIconSolid,
  Bookmark02Icon,
  Bookmark02IconSolid,
  BookOpen02Icon,
  BrowserIconSolid,
  BubbleChatQuestionIcon,
  Bug01Icon,
  CalculatorIcon,
  Calendar03Icon,
  Calendar03IconSolid,
  Camera01Icon,
  Cancel01Icon,
  CancelCircleIcon,
  CancelCircleIconSolid,
  Cash01IconSolid,
  ChampionIconSolid,
  Chart01Icon,
  ChartBarLineIcon,
  ChartCandleIconSolid,
  ChartRoseIconSolid,
  ChartUpIcon,
  CheckmarkBadge01Icon,
  CheckmarkCircle02Icon,
  CheckmarkCircle02IconSolid,
  CheckUnread01Icon,
  CircleArrowDown02IconSolid,
  CircleIcon,
  CircleIconSolid,
  Clock01Icon,
  Clock01IconSolid,
  Clock04IconSolid,
  Coins01Icon,
  Coins01IconSolid,
  CommandIcon,
  Comment03IconSolid,
  ComputerIcon,
  ConfusedIconSolid,
  ConstructionIcon,
  ConstructionIconSolid,
  Copy01Icon,
  Copy01IconSolid,
  DashboardSquare01Icon,
  DashboardSquare01IconSolid,
  Delete02Icon,
  DocumentValidationIcon,
  DollarCircleIcon,
  Download01Icon,
  DropletIcon,
  Edit02Icon,
  Edit03IconSolid,
  ExpandIcon,
  FavouriteIcon,
  FilterVerticalIcon,
  FilterVerticalIconSolid,
  FireIcon,
  FireIconSolid,
  FlashIcon,
  FlashIconSolid,
  GalleryHorizontalEndIcon,
  GiftIcon,
  GiftIconSolid,
  GitBranchIcon,
  Globe02Icon,
  Grid02IconSolid,
  GridViewIconSolid,
  HelpCircleIconSolid,
  HexagonIcon,
  Home01Icon,
  HourglassIcon,
  IdeaIcon,
  Image02IconSolid,
  InformationCircleIconSolid,
  JusticeScale01Icon,
  Layers01Icon,
  Layers01IconSolid,
  LimitationIconSolid,
  Link01Icon,
  Link01IconSolid,
  Link02Icon,
  LinkForwardIconSolid,
  LiveStreaming02IconSolid,
  Loading03Icon,
  Location01Icon,
  Login01Icon,
  Logout01Icon,
  Mail02Icon,
  MarketAnalysisIcon,
  Menu01Icon,
  Message01Icon,
  MinusSignCircleIconSolid,
  MoneyBag01IconSolid,
  MoneyExchange01IconSolid,
  Moon02Icon,
  Moon02IconSolid,
  More01IconSolid,
  MoreHorizontalIcon,
  NeutralIcon,
  Notification02Icon,
  PaintBoardIcon,
  PaintBoardIconSolid,
  Plant01Icon,
  Plant04IconSolid,
  PlugSocketIcon,
  PlusSignCircleIconSolid,
  PlusSignIcon,
  Pulse02Icon,
  RadioButtonIcon,
  RainbowIconSolid,
  Relieved01Icon,
  RepeatIcon,
  Rocket01Icon,
  Rocket01IconSolid,
  RotateClockwiseIcon,
  Search01Icon,
  Search02Icon,
  SearchRemoveIcon,
  SecurityIconSolid,
  SentIcon,
  Settings01Icon,
  Settings02Icon,
  Settings02IconSolid,
  Shapes01IconSolid,
  Shield01Icon,
  ShieldUserIcon,
  ShoppingCart01Icon,
  SidebarLeftIcon,
  SlidersVerticalIcon,
  SmartPhone01Icon,
  SparklesIcon,
  SparklesIconSolid,
  Square01IconSolid,
  SquareLock02Icon,
  SquareLock02IconSolid,
  StarAward01IconSolid,
  StarIcon,
  Sun03Icon,
  Target02IconSolid,
  TaskEdit01IconSolid,
  TextFontIconSolid,
  Tick01IconSolid,
  Tick02Icon,
  Timer01Icon,
  ToggleOnIconSolid,
  Touch01IconSolid,
  TradeUpIcon,
  TradeUpIconSolid,
  Upload01Icon,
  User03Icon,
  User03IconSolid,
  UserCircleIconSolid,
  UserGroup02IconSolid,
  UserGroup03IconSolid,
  UserIcon,
  UserLove01IconSolid,
  UserMultiple02Icon,
  UserMultiple02IconSolid,
  UserMultipleIcon,
  ViewOffIcon,
  VolumeHighIcon,
  VolumeOffIcon,
  Wallet01Icon,
  WalletCardsIconSolid,
  Wrench01IconSolid,
};

export const SOLID_ICONS: ReadonlySet<IconSvgElement> = new Set([
  AddMoneyCircleIconSolid,
  AffiliateIconSolid,
  Agreement01IconSolid,
  AiFileIconSolid,
  Alert01IconSolid,
  ArrowDataTransferHorizontalIconSolid,
  ArrowDown01IconSolid,
  ArrowUp01IconSolid,
  Award01IconSolid,
  BadgeInfoIconSolid,
  Bookmark02IconSolid,
  BrowserIconSolid,
  Calendar03IconSolid,
  CancelCircleIconSolid,
  Cash01IconSolid,
  ChampionIconSolid,
  ChartCandleIconSolid,
  ChartRoseIconSolid,
  CheckmarkCircle02IconSolid,
  CircleArrowDown02IconSolid,
  CircleIconSolid,
  Clock01IconSolid,
  Clock04IconSolid,
  Coins01IconSolid,
  Comment03IconSolid,
  ConfusedIconSolid,
  ConstructionIconSolid,
  Copy01IconSolid,
  DashboardSquare01IconSolid,
  Edit03IconSolid,
  FilterVerticalIconSolid,
  FireIconSolid,
  FlashIconSolid,
  GiftIconSolid,
  Grid02IconSolid,
  GridViewIconSolid,
  HelpCircleIconSolid,
  Image02IconSolid,
  InformationCircleIconSolid,
  Layers01IconSolid,
  LimitationIconSolid,
  Link01IconSolid,
  LinkForwardIconSolid,
  LiveStreaming02IconSolid,
  MinusSignCircleIconSolid,
  MoneyBag01IconSolid,
  MoneyExchange01IconSolid,
  Moon02IconSolid,
  More01IconSolid,
  PaintBoardIconSolid,
  Plant04IconSolid,
  PlusSignCircleIconSolid,
  RainbowIconSolid,
  Rocket01IconSolid,
  SecurityIconSolid,
  Settings02IconSolid,
  Shapes01IconSolid,
  SparklesIconSolid,
  Square01IconSolid,
  SquareLock02IconSolid,
  StarAward01IconSolid,
  Target02IconSolid,
  TaskEdit01IconSolid,
  TextFontIconSolid,
  Tick01IconSolid,
  ToggleOnIconSolid,
  Touch01IconSolid,
  TradeUpIconSolid,
  User03IconSolid,
  UserCircleIconSolid,
  UserGroup02IconSolid,
  UserGroup03IconSolid,
  UserLove01IconSolid,
  UserMultiple02IconSolid,
  WalletCardsIconSolid,
  Wrench01IconSolid,
]);
